/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var version = "1.0.7";

var NotImplementedError = /** @class */ (function (_super) {
    __extends(NotImplementedError, _super);
    function NotImplementedError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NotImplementedError;
}(Error));
function pluralizeRule0(input, case0) {
    return case0;
}
function pluralizeRule1(input, case0, case1) {
    return input === 1 ? case0 : case1;
}
function pluralizeRule2(input, case0, case1) {
    return (input === 0 || input === 1) ? case0 : case1;
}
function pluralizeRule3(input, case0, case1, case2) {
    if (input === 0) {
        return case0;
    }
    if (input % 10 === 1 && input !== 11) {
        return case1;
    }
    return case2;
}
function pluralizeRule4(input, case0, case1, case2, case3) {
    if (input === 1 || input === 11) {
        return case0;
    }
    if (input === 2 || input === 12) {
        return case1;
    }
    if (input >= 3 && input <= 19) {
        return case2;
    }
    return case3;
}
function pluralizeRule5(input, case0, case1, case2) {
    if (input === 1) {
        return case0;
    }
    if (input === 0) {
        return case1;
    }
    input %= 100;
    if (input >= 1 && input <= 19) {
        return case1;
    }
    return case2;
}
function pluralizeRule6(input, case0, case1, case2) {
    input %= 100;
    if (input >= 11 && input <= 19) {
        return case1;
    }
    input %= 10;
    if (input === 1) {
        return case0;
    }
    if (input === 0) {
        return case1;
    }
    return case2;
}
function pluralizeRule7(input, case0, case1, case2) {
    input %= 100;
    if (input >= 5 && input <= 20) {
        return case2;
    }
    input %= 10;
    if (input === 1) {
        return case0;
    }
    if (input >= 2 && input <= 4) {
        return case1;
    }
    return case2;
}
function pluralizeRule8(input, case0, case1, case2) {
    if (input === 1) {
        return case0;
    }
    if (input >= 2 && input <= 4) {
        return case1;
    }
    return case2;
}
function pluralizeRule9(input, case0, case1, case2) {
    if (input === 1) {
        return case0;
    }
    if (input >= 12 && input <= 14) {
        return case2;
    }
    input %= 10;
    if (input >= 2 && input <= 4) {
        return case1;
    }
    return case2;
}
function pluralizeRule10(input, case0, case1, case2, case3) {
    input %= 100;
    if (input === 1) {
        return case0;
    }
    if (input === 2) {
        return case1;
    }
    if (input === 3 || input === 4) {
        return case2;
    }
    return case3;
}
function pluralize(input, langCode, cases) {
    input = Math.abs(input);
    switch (langCode) {
        case 'fa': // Persian
        case 'ja': // Japanese
        case 'ko': // Korean
        case 'lo': // Lao
        case 'th': // Thai
        case 'tr': // Turkish
        case 'zh': // Chinese
            return pluralizeRule0(input, cases[0]);
        case 'ca': // Catalan
        case 'da': // Danish
        case 'de': // German
        case 'el': // Greek
        case 'en': // English
        case 'es': // Spanish
        case 'et': // Estonian
        case 'eu': // Basque
        case 'fi': // Finnish
        case 'fo': // Faroese
        case 'fy': // Frisian
        case 'he': // Hebrew
        case 'hu': // Hungarian
        case 'it': // Italian
        case 'nb': // Norwegian
        case 'nl': // Dutch
        case 'pt': // Portuguese
        case 'sv': // Swedish
        case 'vi': // Vietnamese
            return pluralizeRule1(input, cases[0], cases[1]);
        case 'fr': // French
        case 'pt-BR': // Brazilian Portuguese
            return pluralizeRule2(input, cases[0], cases[1]);
        case 'lv': // Latvian
            return pluralizeRule3(input, cases[0], cases[1], cases[2]);
        case 'gd': // Scottish Gaelic
            return pluralizeRule4(input, cases[0], cases[1], cases[2], cases[3]);
        case 'ro': // Romanian
            return pluralizeRule5(input, cases[0], cases[1], cases[2]);
        case 'lt': // Lithuanian
            return pluralizeRule6(input, cases[0], cases[1], cases[2]);
        case 'be': // Belarusian
        case 'bs': // Bosnian
        case 'hr': // Croatian
        case 'ru': // Russian
        case 'sr': // Serbian
        case 'uk': // Ukrainian
            return pluralizeRule7(input, cases[0], cases[1], cases[2]);
        case 'cs': // Czech
        case 'sk': // Slovak
            return pluralizeRule8(input, cases[0], cases[1], cases[2]);
        case 'pl': // Polish
            return pluralizeRule9(input, cases[0], cases[1], cases[2]);
        case 'sl': // Slovenian
            return pluralizeRule10(input, cases[0], cases[1], cases[2], cases[3]);
        default:
            throw new NotImplementedError("Method with language " + langCode + " not implemented");
    }
}
var vueFilterPluralize = {
    install: function (Vue) {
        Vue.filter('pluralize', pluralize);
    },
    version: version
};

export default vueFilterPluralize;
export { pluralize };
//# sourceMappingURL=vue-filter-pluralize.esm.js.map
